const PageNotFound = () => {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-sm font-semibold text-indigo-600 sm:text-2xl lg:text-4xl">
          404
        </p>
        <h1 className="mt-2 text-xl font-semibold tracking-tight text-gray-900 sm:text-3xl lg:text-5xl">
          Page not found
        </h1>
        <p className="mt-4 text-sm leading-5 text-gray-600 sm:text-base lg:text-lg">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
      </div>
    </main>
  );
};

export default PageNotFound;
